import { BatchConfig } from "@/plugins/user-activity-track/types";
import {
  UserRecentlyAccessedLocation,
  UserRecentlyAccessedTypeMap,
} from "@modules/user-recently-accessed/user-recently-accessed-types";

export const USER_RECENTLY_ACCESSED_LOCAL_STORAGE = {
  SIGNED_URL_PARAMS: "recentlyAccessedSignedUrlParams",
} as const;

export const USER_RECENTLY_ACCESSED_LOCATIONS = {
  ALP_TEMPLATE: "ALP_TEMPLATE",
  CLASS_GROUP: "CLASS_GROUP",
  COMMUNITY_GALLERY: "COMMUNITY_GALLERY",
  MOE_LIBRARY: "MOE_LIBRARY",
  MY_DRIVE: "MY_DRIVE",
} as const;

export const USER_RECENTLY_ACCESSED_TYPES = {
  MODULE: "MODULE",
  MODULE_TEMPLATE: "MODULE_TEMPLATE",
  ASSIGNMENT: "ASSIGNMENT",
} as const;

export const USER_RECENTLY_ACCESSED_LOCATION_LABELS: Record<UserRecentlyAccessedLocation, string> =
  {
    ALP_TEMPLATE: "user_recently_accessed_location_label_alp_template",
    CLASS_GROUP: "user_recently_accessed_location_label_class_group",
    COMMUNITY_GALLERY: "user_recently_accessed_location_label_community_gallery",
    MOE_LIBRARY: "user_recently_accessed_location_label_moe_library",
    MY_DRIVE: "user_recently_accessed_location_label_my_drive",
  };

export const USER_RECENTLY_ACCESSED_TYPE_MAP: UserRecentlyAccessedTypeMap = {
  MODULE: {
    label: "user_recently_accessed_type_label_module",
    icon: "Lesson32",
  },
  MODULE_TEMPLATE: {
    label: "user_recently_accessed_type_label_module_template",
    icon: "Template32",
  },
  ASSIGNMENT: {
    label: "user_recently_accessed_type_label_assignment",
    icon: "Assignment32",
  },
};

export const USER_RECENTLY_ACCESSED_BATCH_CONFIG: BatchConfig = {
  batchDelay: 5000,
  batchSize: 20,
};
